import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import FloatingActionButton from 'components/Shared/FloatingActionButton';
import AddProject from 'components/Projects/AddProject';
import ProjectsGrid from 'components/Projects/ProjectsGrid';
import { FormProvider } from 'context/FormContext';
import AuthCheck from 'components/Shared/AuthCheck';

const tabs = [
    new Tab({ label: "Projects", value: "ProjectsGrid", scope: "Projects", action: "read" }),
    new Tab({ label: "Add Project", value: "addProject", scope: "Projects", action: "create" })
]

const Projects = () => {
    const [activeTab, setActiveTab] = useState("ProjectsGrid");
    return (
        <FormProvider>
            <TabbedPage
                tabs={tabs}
                activeTab={activeTab}
                tabSetterFunc={setActiveTab}
            >
                {(() => {
                    switch (activeTab) {
                        case "ProjectsGrid": return <ProjectsGrid />;
                        case "addProject": return <AddProject CRUDType="INSERT" callback={() => { setActiveTab("ProjectsGrid") }} />;
                        default: return <ProjectsGrid />;
                    }
                })()}
                <AuthCheck scope="Projects" action="create"><FloatingActionButton onClick={() => setActiveTab("addProject")}><AddIcon /></FloatingActionButton></AuthCheck>
            </TabbedPage>
        </FormProvider>
    )
}

export default Projects;